import React, { useEffect, useRef } from "react";
import NailaChat from "naila-chat-sdk";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default function AIAssistant() {
  const { token } = useAuth();
  const chatRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    const chat = NailaChat.init({
      src: "https://naila-ai.invexonline.com/embed",
      token,
    }).onMessage((data) => {
      if (data?.type === "naila-quicklink-action") {
        const action = data?.action;
        const params = action?.params;

        if (action?.type === "open" && action?.link) {
          let finalLink = action.link;

          if (params && Object.keys(params).length > 0) {
            const queryString = new URLSearchParams(params).toString();
            finalLink += finalLink.includes("?")
              ? `&${queryString}`
              : `?${queryString}`;
          }
          navigate(finalLink);
        }
      }
    });

    chatRef.current = chat;

    // Cleanup on unmount
    return () => {
      chat?.destroy?.();
    };
  }, [token]);

  return <div ref={chatRef} />;
}
